__turbopack_context__.v({
  "container": "TidEcW_container",
  "content": "TidEcW_content",
  "fullWidth": "TidEcW_fullWidth",
  "image": "TidEcW_image",
  "imageContainer": "TidEcW_imageContainer",
});
